import { InfoFilled } from '@element-plus/icons-vue'
import { normalizeOptions } from '@formkit/inputs'
import { ElButton, ElCheckbox, ElCheckboxGroup, ElDialog, ElIcon } from 'element-plus'
import { computed, defineComponent, h, onMounted, ref } from 'vue'

export default defineComponent({
  props: {
    context: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const isDialogVisible = ref(false)
    const selectedInfoText = ref('')
    const selectedModalTitle = ref('')

    const value = computed({
      get: () => props.context.value,
      set: (val) => props.context.node.input(val),
    })

    const options = computed(() =>
      normalizeOptions(props.context.attrs?.options ?? []).map((option) => ({
        ...option,
        info: option.info || null,
        modalTitle: option.modalTitle || '',
      })),
    )

    const checkboxClasses = computed(() => props.context.attrs?.checkboxClasses || '')

    const showDialog = (info, title) => {
      selectedInfoText.value = info
      selectedModalTitle.value = title || ''
      isDialogVisible.value = true
    }

    onMounted(() => {
      if (!value?.value?.length && props.context.attrs?.defaultValue) {
        props.context.node.input(props.context.attrs.defaultValue)
      }
    })

    return () =>
      h('div', [
        h(
          ElCheckboxGroup,
          {
            modelValue: value.value,
            'onUpdate:modelValue': (val) => (value.value = val),
            class: checkboxClasses.value,
          },
          () =>
            options.value.map((option) =>
              h('div', { class: 'flex items-center', key: option.value }, [
                h(ElCheckbox, { label: option.value }, () => option.label),
                option.info
                  ? h(
                      ElIcon,
                      {
                        class: 'ml-2 cursor-pointer text-primary-500 mb-2',
                        size: '16',
                        onClick: (e) => {
                          e.stopPropagation()
                          showDialog(option.info, option.modalTitle)
                        },
                      },
                      () => h(InfoFilled),
                    )
                  : null,
              ]),
            ),
        ),
        h(
          ElDialog,
          {
            modelValue: isDialogVisible.value,
            'onUpdate:modelValue': (val) => (isDialogVisible.value = val),
            title: selectedModalTitle.value,
            width: '75%',
            appendToBody: true,
            zIndex: 4000,
          },
          {
            default: () =>
              h('div', {
                innerHTML: selectedInfoText.value,
                style: {
                  maxHeight: '400px',
                  overflowY: 'auto',
                  padding: '16px',
                },
              }),
            footer: () =>
              h(
                'div',
                { class: 'text-right' },
                h(ElButton, { type: 'primary', onClick: () => (isDialogVisible.value = false) }, () => 'Close'),
              ),
          },
        ),
      ])
  },
})
